import React from "react"
import { Link, NavLink } from "react-router-dom";

import Button from '../newButton/button'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import userLogo from '../../assets/user_logo.svg'
// import { NotificationUser } from '../../queries/notification'
// import { Query } from 'react-apollo'
import './navbar.scss'
import logoPurple from '../../assets/Logo-Oito-1.png'
import logoWhite from '../../assets/oito-white.png'
import dayjs from 'dayjs'
import { GraphQLClient } from 'graphql-request'
import { endpoint } from '../../queries/endpoint'
// import logoOrange from '../../assets/oito.png'
import { Mutation } from "react-apollo"
import { ReadNotification } from "../../queries/notification"
import Loading from '../loading/loading'

export default class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showStatus: 0,
            dropdownActive: false,
            contrastNav: false,
            hasSlided: false,
            player: null,
            dropdownProfileActive: false,
            dropdownNotificationActive: false,
            notList: null,
            newNot: 0,
        }

        const cache = JSON.parse(sessionStorage.getItem('OITO'));
        if (cache) {
            this.player = cache.user

            const client = new GraphQLClient(endpoint, {
                headers: {
                    Authorization: `Bearer ${cache.token}`,
                },
            })

            if (cache.user.role === "USER") {
                this.state = { ADM: false }
            } else {
                this.state = { ADM: true }
            }


            // client.request(`
            // query{
            //     user(id: "${cache.user.id}"){
            //       name
            //       notifications(first: 3, orderBy: id_DESC){
            //         id
            //         createdAt
            //         description
            //         link
            //         status
            //         title
            //         user {
            //           name
            //         }
            //       }
            //     }
            //   }
            // `).then(
                client.request(`
            query{
                user(id: "${cache.user.id}"){
                  name
                  notifications{
                    id
                    createdAt
                    description
                    link
                    status
                    title
                    user {
                      name
                    }
                  }
                }
              }
            `).then(
                res => {
                    if (res.error) throw new Error()
                    // console.log(res.allPlayers[0].notifications)
                    if (this.state.notList === null) {
                        this.setState({ notList: res.user.notifications.slice(0, 3) })
                    }
                }
            )

            // client.request(`
            // query {
            //     _allNotificationsMeta(filter: {
            //     AND:[ {
            //       player: {
            //         id: "${cache.user.id}" 
            //       }
            //     },
            //     {
            //       status: false
            //     }
            //     ]
            //   }){
            //     count
            //   }
            //   }
            // `).then(
            //     res => {
            //         if (res.error) throw new Error()
            //         // console.log(res.allPlayers[0].notifications)
            //         if (this.state.newNot === 0 && res._allNotificationsMeta.count > 0) {
            //             this.setState({ newNot: res._allNotificationsMeta.count })
            //         }
            //     }
            // )
        } else {
            //login
            this.setState({
                showAlert: true,
                typeAlert: 'error',
                titleAlert: 'Você não está logado!',
                messageAlert: 'Entre ou cadastre-se. É gratuito!',
                onClose: () => window.location.href = '/login'
            })
        }

        if (this.props.logoContrastPurple) {
            window.removeEventListener('scroll', this.changeNavbarBgContrast);
        } else {
            window.addEventListener('scroll', this.changeNavbarBg);
        }

        // console.log(cache.user.player);

        this.getRouteToShowItem();
        if (this.props.logoContrastPurple) {
            window.addEventListener('scroll', this.changeNavbarBgContrast);
            this.setState({ contrastNav: true })
        } else {
            window.addEventListener('scroll', this.changeNavbarBg);
        }

        this.readNotification = (id, link, ReadNotification) => {
            ReadNotification({
                variables: {
                    id
                }
            }).then(
                res => {
                    // console.log(res)
                    this.setState({ dropdownProfileActive: !this.state.dropdownNotificationActive })
                    window.location.href = link
                }
            )
        }

    }

    dropdownAction = () => {
        // console.log('working');
        this.setState({ dropdownActive: !this.state.dropdownActive })
    };

    changeNavbarBgContrast = () => {
        let scrollPosition = window.scrollY;

        if (scrollPosition > 5) {
            this.setState({ hasSlided: true, contrastNav: false })
        }

        if (scrollPosition < 5) {
            this.setState({ hasSlided: false, contrastNav: true })
        }
    };

    changeNavbarBg = () => {
        let scrollPosition = window.scrollY;

        if (scrollPosition > 5) {
            this.setState({ hasSlided: true })
        }

        if (scrollPosition < 5) {
            this.setState({ hasSlided: false })
        }
    };

    getRouteToShowItem = () => {
        let route = window.location.pathname;
        switch (route) {
            case '/':
                this.setState({ showStatus: 0 });
                break;
            case '/quemSomos':
                this.setState({ showStatus: 0 });
                break;
            case '/termosUso':
                this.setState({ showStatus: 0 });
                break;
            case '/faq':
                this.setState({ showStatus: 0 });
                break;
            case '/login':
                this.setState({ showStatus: 1 });
                break;
            case '/cadastro':
                this.setState({ showStatus: 1 });
                break;
            default:
                this.setState({ showStatus: 0 });
        }
    };

    openNotificationDropdown = (e) => {
        // console.log(this.state.dropdownNotificationActive);
        e.preventDefault()
        this.setState({ dropdownNotificationActive: !this.state.dropdownNotificationActive });

        window.setTimeout(() => {
            if (this.state.dropdownNotificationActive) {
                this.setState({ dropdownProfileActive: !this.state.dropdownNotificationActive });
            }
        }, 20000)
    };

    openProfileDropdown = () => {
        this.setState({ dropdownProfileActive: !this.state.dropdownProfileActive });

        window.setTimeout(() => {
            if (this.state.dropdownProfileActive) {
                this.setState({ dropdownProfileActive: !this.state.dropdownProfileActive });
            }
        }, 5000)
    };

    logout = (e) => {
        e.preventDefault()
        sessionStorage.clear()
        window.location.href = '/'
    };

    componentDidMount() {

        this.getRouteToShowItem();
        if (this.props.logoContrastPurple) {
            window.addEventListener('scroll', this.changeNavbarBgContrast);
            this.setState({ contrastNav: true })
        } else {
            window.addEventListener('scroll', this.changeNavbarBg);
        }
    }
    render() {
        // const {
        //     logoContrastPurple
        // } = this.props;
        return (
            <nav className='navbar' style={this.state.hasSlided ? { backgroundColor: 'white', boxShadow: '0 2px 5px #dadada' } : null}>
                <div>
                    <div onClick={this.dropdownAction} style={this.state.contrastNav ? { color: 'white' } : { color: '#65519d' }}><FontAwesomeIcon icon={faBars} size={'2x'} /></div>
                    <Link to='/'>{this.state.contrastNav ? <img alt={'Logo Oito Branco'} src={logoWhite} /> : <img alt={'Logo Oito Roxo'} src={logoPurple} />}</Link>
                    <ul className={this.state.contrastNav ? 'whiteColor' : 'orangeColor'}>
                        {this.state.showStatus === 1 ? <NavLink exact to="/" activeClassName='selected'><li>Home</li></NavLink> : null}
                        {this.state.showStatus === 0 ? <NavLink exact to="/anuncios" activeClassName='selected'><li>Encontrar um profissional</li></NavLink> : null}
                        {this.player ? null : this.state.showStatus === 0 ? <NavLink exact to="/cadastro" activeClassName='selected'><li>Anunciar</li></NavLink> : null}
                        {/* {this.player ? null : <NavLink exact to="/quemSomos" activeClassName='selected'><li>Saiba mais</li></NavLink>} */}
                        {this.state.showStatus === 0 ? <NavLink exact to="/blog" activeClassName='selected'><li>Blog</li></NavLink> : null}
                    </ul>
                    {!this.player ? <div className="callact">
                        <Link to={'/login'}><Button name={'entrar'} /></Link></div> : null}
                </div>

                <div className={this.state.dropdownActive ? 'dropdown active' : 'dropdown'} onClick={this.dropdownAction}>
                    {/* <div onClick={this.dropdownAction}><FontAwesomeIcon icon={faTimes} size={'2x'} /></div> */}
                    <ul className='dropdown-links'>
                        {this.player ?
                            <div className="row middle-xs">
                                <div className='ava'>
                                    <img src={this.player.photo ? this.player.photo : userLogo} alt={this.player.name} />
                                </div>
                                <div className='name'>
                                    <span>Oi, {this.player.name.split(' ')[0]}</span><br />
                                    <NavLink exact to="/perfil" activeClassName="active-route">Minha conta <FontAwesomeIcon icon={faChevronRight} size='0.8em' /></NavLink>
                                </div>
                            </div>
                            : <>
                                <NavLink exact to="/login" activeClassName="active-route"><li className="login">Entrar</li></NavLink>
                                <NavLink exact to="/cadastro" activeClassName="active-route"><li className="login">Cadastrar</li></NavLink>
                            </>}

                        <NavLink exact to="/" activeClassName="active-route"><li>Início</li></NavLink>
                        {this.state.ADM ? <NavLink exact to="/painel" activeClassName="active-route"><li>Painel</li></NavLink> : null}
                        {this.player ? <NavLink exact to="/perfil/notifications" activeClassName="active-route"><li>Notificações</li></NavLink> : null}
                        <NavLink exact to="/anuncios" activeClassName="active-route"><li>Encontrar um profissional</li></NavLink>
                        <NavLink exact to="/blog" activeClassName="active-route"><li>Blog</li></NavLink>
                        {this.player ? null : <NavLink exact to="/cadastro" activeClassName="active-route"><li>Anunciar</li></NavLink>}
                        <NavLink exact to='/faq' activeClassName="active-route"><li>Perguntas frequentes</li></NavLink>
                        <NavLink exact to='/faleConosco' activeClassName="active-route"><li>Fale Conosco</li></NavLink>
                        {this.player ? <button onClick={(e) => this.logout(e)}><li>Sair</li></button> : null}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                            <a href='https://www.instagram.com/oito.app' target='_blank' rel="noopener noreferrer" >
                                <div>
                                    <svg style={{ width: '35px', height: '35px' }} viewBox="0 0 30 30">
                                        <path fill="#707070" d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" />
                                    </svg>
                                </div>
                            </a>
                            <a href='https://www.facebook.com/oitojobs/' target='_blank' rel="noopener noreferrer">
                                <div>
                                    <svg style={{ width: '35px', height: '35px' }} viewBox="0 0 30 30">
                                        <path fill="#707070" d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z" />
                                    </svg>
                                </div>
                            </a>
                        </div>
                    </ul>
                </div>

                {this.player ? <div>
                    <div className={'userInfo'}>
                        {/* <div onClick={this.openNotificationDropdown}>
                            <svg style={{ width: "22px", height: "22px" }} viewBox="0 0 24 24">
                                <path fill="#707070" d="M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M14,21A2,2 0 0,1 12,23A2,2 0 0,1 10,21" />
                            </svg>
                        </div> */}
                        <div onClick={this.openProfileDropdown} className={'name'}>{this.player.name.split(' ')[0]}</div>
                        <div onClick={this.openProfileDropdown}><img src={this.player.photo ? this.player.photo : userLogo} alt={this.player.name} />{this.state.newNot ? <span className="badge">{this.state.newNot}</span> : null}</div>
                    </div>
                </div> :
                    this.state.showStatus === 0 ? <div>
                        <Link to={'/cadastro'}><Button style={this.state.contrastNav ? { background: "none", color: "white", boxShadow: "none" } : { background: "none", color: "#ff8000", boxShadow: "none" }} name={'cadastrar'} /></Link>
                        <Link to={'/login'}><Button name={'entrar'} /></Link></div> : null}

                {this.state.dropdownProfileActive ? <div id={'DropdownProfile'}>
                    <ul>
                        <NavLink to={'/perfil'} activeClassName="activedDropProfile"><li>Minha conta</li></NavLink>
                        {this.state.ADM ? <NavLink to="/painel" activeClassName="activedDropProfile"><li>Painel</li></NavLink> : null}
                        <NavLink to={'/perfil/notifications'} onClick={(e) => this.openNotificationDropdown(e)} activeClassName="activedDropProfile"><li>Notificações {this.state.newNot ? <span className="badge list">{this.state.newNot}</span> : null}</li></NavLink>
                        <Link to={"/"} onClick={(e) => this.logout(e)}><li>Sair</li></Link>
                    </ul>
                </div> : null}

                {this.state.dropdownNotificationActive ?
                    <div id={'NotificationDropdown'}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ flex: '0 0 33.33%' }}></div>
                            <div style={{ flex: '0 0 33.33%', textAlign: 'right' }}><h4>Notificações</h4></div>
                            <div style={{ flex: '0 0 33.33%', textAlign: 'center' }} onClick={this.openNotificationDropdown}>
                                <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
                                    <path fill="#5f5f5f" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                                </svg>
                            </div>
                        </div>
                        <div className={'content'}>
                            <small>Últimas notificações</small>
                            {this.state.notList.length > 0 ?
                                this.state.notList.map((not, i) =>
                                    <Mutation mutation={ReadNotification} key={i}>
                                        {(ReadNotification, { loading, error }) => {
                                            if (loading) return <Loading />
                                            if (error) return console.log(error)
                                            return <p key={i} style={not.status ? null :
                                                { backgroundColor: "#f4f4f4", color: "#6550A1" }}
                                                onClick={() => this.readNotification(not.id, not.link, ReadNotification)}>
                                                {not.description} Data:{dayjs(not.date).format('DD/MM/YYYY')}</p>
                                        }}
                                    </Mutation>
                                )
                                : <span>Não há notificações</span>
                            }
                        </div>
                        <div className={'btnNot'}>
                            <Link to={'/perfil/notifications'} onClick={() => this.setState({ dropdownProfileActive: !this.state.dropdownNotificationActive })}>Ver mais notificações</Link>
                        </div>
                    </div>
                    : null}
            </nav>
        )
    }
}
